import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { PARSLEY_NEW_ITEMS_PATH, PARSLEY_PATH } from '@/helpers/parsley'

// Two directions of the same job: start from a product and find its Parsley
// item, or start from a Parsley item that has no product yet.
const TABS = [
  { id: 'products', name: 'Your products', path: PARSLEY_PATH },
  { id: 'new', name: 'New from Parsley', path: PARSLEY_NEW_ITEMS_PATH }
]

export const parsleyTabs = currentPath => TABS.map(tab => ({ ...tab, active: currentPath === tab.path }))

export const parsleyTab = currentPath => parsleyTabs(currentPath).find(tab => tab.active)?.id ?? 'products'

// The tabs in the shape SecondaryTop's `sections` prop expects. Route-backed,
// so `action` navigates and `active` comes from the route.
export function useParsleyTabs() {
  const route = useRoute()
  const router = useRouter()

  const tabs = computed(() =>
    parsleyTabs(route.path).map(tab => ({
      id: tab.id,
      name: tab.name,
      active: tab.active,
      action: () => router.push(tab.path)
    }))
  )

  return { tabs, tab: computed(() => parsleyTab(route.path)) }
}
